import React, { Component } from 'react';
import { Button, Input, Loader } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import $ from "jquery";

import serverName from '../../functions/server';

class OtherFiles extends Component {

  state = {
    otherFile: null, 
    out: []
  }

  saveFile() {
    let context = this;
    let url_string = window.location.href; 
    var url = new URL(url_string);
    var shopId = url.searchParams.get("shopId");
    var formData = new FormData();
    formData.append('file', this.state.otherFile);
    formData.append('file_name', this.state.fileName);
    formData.append('file_size', this.state.otherFile["size"]);
    formData.append('shop_id', shopId);
    formData.append('product_id', this.props.productId);
    formData.append('original_file_name', this.state.otherFile["name"]);
    
    let server = serverName() + '/products/addattachment.php';
    this.setState({ load: true });
    $.ajax({
      type: 'POST', processData: false, contentType: false,
      data: formData, url: server,
      success: function (data) {
        if (data == 1) {
          alert("Uploaded Successfully!!!");
          context.setState({ addAttachment: false, otherFile: null, fileName: "", load: false });
          context.getOtherAttachment();
        }
        else {
          alert("Failed to Upload");
          context.setState({ load: false });
        } 
      },
      error: function (data, status) {
        context.setState({ load: false });
        console.log(data);
        console.log(status);
        alert("Failed to Add Product");
      }
    });
  }

  getOtherAttachment = () => {
    let context = this;
    let url = serverName() + '/products/getotherattachment.php';
    let data = {id: this.props.productId};
    $.ajax({
      url: url,
      data, type: 'POST',
    }).done((data) => {
      let out = 1;
      try {
        out = JSON.parse(data);
      } catch(e) {}
      context.setState({
        out: out,
        load: false, 
        addAttachment: true
      });
    });
  }

  delete = (file) => {
    let data = { id: file.id, path: "https://s3.ap-south-1.amazonaws.com/business.strackit.com/"+file.file_path, type: "otherattachment" } 
    let context = this;
    let url = serverName() + '/products/deleteimage.php';
    this.setState({ loading: true });
    $.ajax({
      url: url,
      data, type: 'POST',
    }).done((data) => {
      try {
        if (data == 1) {
          context.getOtherAttachment();
          this.setState({ loading: false });
        }
        else {
          alert("Failed to Delete")
          this.setState({ loading: false });
        }
      } catch (error) {
        alert("error");
        this.setState({ loading: false });
      }
    });
  }

  render() {
    return (
      <div>
        <Button primary onClick={ () => this.getOtherAttachment()} fluid>
          Add Attachment
        </Button>
        <Dialog fullWidth={true} maxWidth={"sm"} onClose={ () => { this.setState({ addAttachment: false }) }} aria-labelledby="simple-dialog-title"  open={this.state.addAttachment}>
          <DialogTitle id="simple-dialog-title">Add Attachment</DialogTitle>
          <DialogContent>
          <table border="1" width={"100%"}>
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>File Name</th>
                <th>File Size (in KB)</th>
                <th>Upload On</th>
                <th>Download</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              { this.state.out && this.state.out.length > 0 ?
                this.state.out.map((file, index) => {
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{file.file_name}</td>
                      <td>{file.file_size}</td>
                      <td>{file.created_on}</td>
                      <td style={{ cursor: "pointer", color: "blue" }} onClick={() => {
                        window.open(
                          "https://s3.ap-south-1.amazonaws.com/business.strackit.com/" +
                            file.file_path,
                          "_blank"
                        );
                      }}>Download</td>
                      <td onClick={() => this.delete(file)}>{ this.state.loading ? <Loader active inline /> : "Delete" }</td>
                    </tr>
                  );
                }
                )
                :
                <tr>
                  <td colSpan={4}>No Files</td>
                </tr>
              }
            </tbody>
          </table>
          <center>
            <br/>
            {
              this.state.otherFile ? 
              <table border="1" width={"100%"}>
                <tr>
                  <th>Choosed File</th>
                  <th>{this.state.otherFile["name"]}</th>
                </tr>
                <tr>
                  <th>File Size</th>
                  <th>{this.state.otherFile["size"]} KB</th>
                </tr>
                <tr>
                  <th>File Name</th>
                  <th><Input onChange={ (event) => this.setState({ fileName: event.target.value }) } value={this.state.fileName} fluid /></th>
                </tr>
              </table>
              : 
              <input type='file' 
                  onChange={(e) => {
                    console.log(e.target.files[0]);
                  this.setState({ otherFile: e.target.files[0], fileName: e.target.files[0]["name"] });
                  }}
              />
            }
          </center>
            
            
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ addAttachment: false }) }} color="primary">Cancel</Button>
            <Button loading={this.state.load} onClick={this.saveFile.bind(this)} color="primary" autoFocus>Save</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default OtherFiles;
